import Success from "../components/success"

export default function Checkout() {
    return (
        < Success />
    )
}